var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ccm-tag'),_vm._v(" "),_c('matomo-tag'),_vm._v(" "),_c('div',{staticClass:"app"},[_c('application-header'),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"main-content"},[_c('router-view')],1)]),_vm._v(" "),_c('div',{staticClass:"wave"}),_vm._v(" "),_c('application-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }